import { defineMessages } from 'react-intl';

export const accessoriesMessages = defineMessages({
  accessoriesPopupBoxText: {
    id: 'pd.accessories.popupBox',
    defaultMessage:
      'Tento produkt má příslušentví, které se vám bude hodit ({count})',
  },
  accessoriesContentTitle: {
    id: 'pd.accessories.content.title',
    defaultMessage: 'Příslušenství pro {productName} ({count})',
  },
  accessoriesShowOtherVariants: {
    id: 'pd.accessories.show.other.variants',
    defaultMessage: 'Zobrazit varianty',
  },
});
